import { Link } from 'react-router-dom'

interface IntakeProgressStripProps {
  savedCount: number
  turnsRemaining: number | null
  /** Free-tier numbers; cap is null for Pro (unlimited). */
  storyCount: number
  cap: number | null
}

export function IntakeProgressStrip({
  savedCount,
  turnsRemaining,
  storyCount,
  cap,
}: IntakeProgressStripProps) {
  const slotsLeft = cap === null ? null : Math.max(cap - storyCount, 0)

  return (
    <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 rounded-xl border border-border bg-muted/30 px-4 py-2.5 text-xs">
      <p>
        <span className="font-semibold">{savedCount}</span>{' '}
        <span className="text-muted-foreground">
          {savedCount === 1 ? 'story' : 'stories'} saved this conversation
        </span>
      </p>
      <div className="flex items-center gap-3 text-muted-foreground">
        {turnsRemaining !== null && (
          <span>
            {turnsRemaining === 0
              ? 'No questions left'
              : `${turnsRemaining} question${turnsRemaining === 1 ? '' : 's'} left`}
          </span>
        )}
        {slotsLeft !== null && (
          <span>
            {slotsLeft === 0 ? (
              <Link to="/settings" className="font-medium text-primary hover:underline">
                Bank full — upgrade
              </Link>
            ) : (
              `${slotsLeft} free slot${slotsLeft === 1 ? '' : 's'} left`
            )}
          </span>
        )}
      </div>
    </div>
  )
}
